import {CreateCheckinCycleFormData} from './types';

const normalizeFormData = (data: CreateCheckinCycleFormData) => ({
  ...data,
  cadence: {
    ...data.cadence,
    selectedTime: {
      ...data.cadence.selectedTime,
      error: '',
    },
  },
});

export const cloneFormData = (
  data: CreateCheckinCycleFormData,
): CreateCheckinCycleFormData =>
  JSON.parse(JSON.stringify(data)) as CreateCheckinCycleFormData;

export const hasFormDataChanged = (
  current: CreateCheckinCycleFormData,
  baseline: CreateCheckinCycleFormData,
) =>
  JSON.stringify(normalizeFormData(current)) !==
  JSON.stringify(normalizeFormData(baseline));
